/**
 * DTO para Petición de Envío y Programación de Notificaciones
 */

import {
  NotificationFrequency,
  NotificationSendBy,
  NotificationSendTo
} from '@enums';

export class SendNotificationRequestDto {
  title: string = '';
  message: string = '';
  send_to: NotificationSendTo = NotificationSendTo.ALL_DRIVERS;
  send_by: NotificationSendBy = NotificationSendBy.PUSH;
  driver_ids?: number[];

  // Campos para programación (opcionales)
  date?: string; // YYYY-MM-DD
  time?: string; // HH:mm:ss
  timezone?: string = 'Europe/Madrid';
  repeat?: boolean = false;
  frequency?: NotificationFrequency;
  every?: number = 1;
  end_date?: string; // YYYY-MM-DD
  max_occurrences?: number;
  weekdays?: string[]; // ['MONDAY', 'TUESDAY', ...]
  month_day?: number; // 1-31
  weekday?: string; // 'TUESDAY'
  nth_weekday?: number; // 1, 2, 3, 4

  constructor(data: Partial<SendNotificationRequestDto> = {}) {
    Object.assign(this, data);
  }

  static fromJson(json: any): SendNotificationRequestDto {
    const dto = new SendNotificationRequestDto();
    if (!json) return dto;
    Object.assign(dto, json);
    return dto;
  }

  toJson(): Record<string, any> {
    const payload: Record<string, any> = {
      title: this.title,
      message: this.message,
      send_to: this.send_to,
      send_by: this.send_by
    };

    if (this.send_to === 'SPECIFIC_DRIVERS' && this.driver_ids && this.driver_ids.length > 0) {
      payload['driver_ids'] = this.driver_ids;
    }

    if (this.date) payload['date'] = this.date;
    if (this.time) payload['time'] = this.time;
    if (this.timezone) payload['timezone'] = this.timezone;
    if (this.repeat !== undefined) payload['repeat'] = this.repeat;
    if (this.frequency) payload['frequency'] = this.frequency;
    if (this.every !== undefined) payload['every'] = this.every;
    if (this.end_date) payload['end_date'] = this.end_date;
    if (this.max_occurrences !== undefined && this.max_occurrences !== null) {
      payload['max_occurrences'] = this.max_occurrences;
    }
    if (this.weekdays && this.weekdays.length > 0) {
      payload['weekdays'] = this.weekdays;
    }
    if (this.month_day !== undefined && this.month_day !== null) {
      payload['month_day'] = this.month_day;
    }
    if (this.weekday) payload['weekday'] = this.weekday;
    if (this.nth_weekday !== undefined && this.nth_weekday !== null) {
      payload['nth_weekday'] = this.nth_weekday;
    }

    return payload;
  }
}

export class SendNotificationResponseDto {
  message: string = '';
  scheduled: string | null = null;
  campaign_id: number = 0;
  scheduled_notification_id?: number;

  constructor(data: Partial<SendNotificationResponseDto> = {}) {
    Object.assign(this, data);
  }

  static fromJson(json: any): SendNotificationResponseDto {
    const dto = new SendNotificationResponseDto();
    if (!json) return dto;
    dto.message = json.message ?? '';
    dto.scheduled = json.scheduled ?? null;
    dto.campaign_id = json.campaign_id ?? 0;
    dto.scheduled_notification_id = json.scheduled_notification_id ?? json.scheduled_task_id;
    return dto;
  }
}
